import {Injectable} from '@angular/core';
import {PaginatedSearchRequest, PaginatedSearchResponse} from "src/app/model/pagination/pagination";
import {AppResponse} from "./app-response.model";
import {User, UserQuery} from "src/app/auth/auth.model";
import {Observable} from "rxjs";
import {optimistic} from "./common-http.service";
import {AuthHttpService} from "./auth-http.service";

@Injectable({
  providedIn: 'root'
})
export class UsersApiService {

  constructor(
    private authHttp: AuthHttpService
  ) {
  }

  search(search: PaginatedSearchRequest<UserQuery>): Observable<PaginatedSearchResponse<User>> {
    return this.authHttp.post<PaginatedSearchResponse<User>>("/users/search", search).pipe(optimistic);
  }

  save(user: User): Observable<AppResponse<void>> {
    return this.authHttp.post<void>("/users", user);
  }

  update(user: User): Observable<AppResponse<void>> {
    return this.authHttp.put<void>("/users/" + user.id, user);
  }

  delete(user: User): Observable<AppResponse<void>> {
    return this.authHttp.delete<void>("/users/" + user.id);
  }
}
